module.exports = __webpack_public_path__ + "static/media/google-play-badge.4584ebe6.png";